/**
 * Contacts JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Contacts
 */
class Contacts {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {


        // The search input
        this.searchInput = $( document.getElementById( 'js-contactsearch-input' ) );

        // The office select
        this.officeSelect = $( document.getElementById( 'js-officetype-select' ) );

        // The tag filters.
        this.filters = $( '.js-searchfilter' );

        // The first caching of all the events before hiding anything.
        this.contacts =  $( '.js-contact' );

        // The containers for the search result indicator.
        this.resultNumberContainer = $( '.js-searchresults-number' );
        this.resultWordContainer   = $( '.js-searchresults-text' );

        // Use localized strings from the theme.
        this.strings = {
            'result': themeData.themeStrings.contacts.search.result,
            'results': themeData.themeStrings.contacts.search.results
        };
    }

    /**
     * All events of the class.
     * @return {void}
     */
    events() {

        // Set a timeout variable to fire search only after user stops typing.
        let timeout = null;

        // Bind a handler to the search text input box and fire a filtering method when the value changes if the word has at least three letters
        $( this.searchInput ).on( 'input', ( e ) =>  {

            // Clear the timeout if there was any set so that the method fires
            // only when the final timeout time has passed.
            clearTimeout( timeout );
            timeout = setTimeout( () => {
                this.FilterContactsByName( e, this.searchInput.val() );
            }, 500 );

        });


        // Bind a handler to the select box and fire a filtering method when the value changes.
        $( this.officeSelect ).on( 'change', ( e ) =>  {
            const selectValue = this.officeSelect.val();
            this.FilterContactsByOffice( e, selectValue );
        });

        // Loop through filters and bind a click handler to each of them.
        this.filters.each( ( index, filter ) => {

            // Bind a click handler to each filter.
            $( filter ).on( 'click', ( e ) =>  {

                filter.classList.toggle( 'js-active' );
                this.FilterContactsByTags( e );

            });

        });
    }

    /**
     * With this method we make the changes that occur in the contact cards
     * when the text input changes.
     *
     * @param {event object} e
     */
    FilterContactsByName( e, inputText ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // Remove the 'selected' class from every item.
        this.contacts.removeClass( 'js-contact--selected-name' );

        // This trims whitespace from the input.
        const formattedInputText = $.trim( inputText ).toLowerCase();

        // If the text is longer than two characters filter the cards.
        if ( formattedInputText.length > 2 ) {

            // Loop through each of the item from the initial page load.
            this.contacts.each( ( index, contact ) => {

                // Get the name data-attribute.
                const contactName = contact.dataset.name;

                // If the written text input is found in the name, add a class to the card.
                if ( typeof contactName !== 'undefined' ) {

                    if ( contactName.indexOf( formattedInputText ) > -1 ) {
                        contact.classList.add( 'js-contact--selected-name' );
                    }
                }

            });

        } else { // If the input field's text's length is less than two, show all cards.

            this.contacts.each( ( index, contact ) => {
                contact.classList.add( 'js-contact--selected-name' );
            });
        }

        this.CountResults();
    }


    /**
     * With this method we make the changes that occur in the contact cards
     * when a select box option is chosen.
     *
     * @param {event object} e
     */
    FilterContactsByOffice( e, officeID ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // Remove the 'selected' class from every item.
        this.contacts.removeClass( 'js-contact--selected-office' );


        if ( officeID !== 'all' ) {

            // Loop through each of the item from the initial page load.
            this.contacts.each( ( index, contact ) => {

                // Store the comma-separated list of the items' offices.
                // Each item can have more than one.
                const contactOffices = contact.dataset.offices;

                // If the item has offices, make an array of them
                // and check if the office ID passed from the select input change is
                // found in the array. If it is, add 'selected' class modifier to the item.
                if ( typeof contactOffices !== 'undefined' ) {

                    const contactOfficesArray = contactOffices.split( ',' );

                    if ( contactOfficesArray.indexOf( officeID ) > -1 ) {

                        contact.classList.add( 'js-contact--selected-office' );
                    }
                }

            });

        } else { // If the select box's value is 'all', add 'selected' modifier to all cards.

            this.contacts.each( ( index, contact ) => {
                contact.classList.add( 'js-contact--selected-office' );
            });
        }

        this.CountResults();
    }

    /**
     * With this method we make the changes that occur in the contact cards
     * when the filters are clicked.
     *
     * @param {event object} e
     */
    FilterContactsByTags( e ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // Remove the 'selected' class from every item.
        this.contacts.removeClass( 'js-contact--selected-tag' );

        const activeFilters = [];

        // Loop through the tag filters and check which ones are active.
        // Add active filters to an array and use it later on.
        this.filters.each( ( index, filter ) => {

            // Check if the filter is active.
            if ( filter.classList.contains( 'js-active' ) ) {

                // Get the tag from the filter button's data-attribute 'filter-tag'.
                const filterTag  = filter.dataset.filterTag.toLowerCase();
                activeFilters.push( filterTag );
            }
        });

        // If there were active filters, check each contact card's data-tags against them.
        // Then show or hide each contact correspondingly.
        if ( activeFilters.length > 0 ) {

            // Loop through each of the item from the initial page load.
            this.contacts.each( ( index, contact ) => {

                // Store the comma-separated list of the items' tags.
                // Each item can have more than one.
                const contactTags = contact.dataset.tags;

                // If the item has tags, make an array of them
                // and check if the filter tag passed from the filter button click is
                // found in the array. If it is, add 'selected' class modifier to the item.
                if ( typeof contactTags !== 'undefined' ) {

                    const contactTagsArray = contactTags.split( ',' );

                    activeFilters.forEach( ( filterTag ) => {

                        if ( contactTagsArray.indexOf( filterTag ) > -1 ) {
                            contact.classList.add( 'js-contact--selected-tag' );
                        }

                    });

                }

            });

        } else { // If there are no active filters, add 'selected' modifier to all cards.

            this.contacts.each( ( index, contact ) => {
                contact.classList.add( 'js-contact--selected-tag' );
            });
        }

        this.CountResults();
    }

    CountResults() {

        // Initialize needed variables.
        const results         = [];
        let visibleByName     = false;
        let visibleByoffice   = false;
        let visibleByTags     = false;
        let resultWord        = '';

        // Count each item that has all needed classes and append
        // them to an array from which we check the length.
        this.contacts.each( ( index, contact ) => {

            visibleByName   = contact.classList.contains( 'js-contact--selected-name' );
            visibleByoffice = contact.classList.contains( 'js-contact--selected-office' );
            visibleByTags   = contact.classList.contains( 'js-contact--selected-tag' );

            if ( visibleByName && visibleByoffice && visibleByTags ) {
                results.push( contact );
            }
        });

        // Set the correct localized string for results according to the amount.
        if ( results.length === 0 || results.length > 1 ) {
            resultWord = this.strings.results;
        } else {
            resultWord = this.strings.result;
        }

        // Manipulate the search result container html.
        this.resultNumberContainer.html( results.length );
        this.resultWordContainer.html( resultWord );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.CountResults();
    }
}

// Export the class reference.
module.exports = Contacts;



// WEBPACK FOOTER //
// ./assets/scripts/contacts.js